import {Component, Inject} from "@angular/core";
import {QuestionCardDirective} from "../../../directives/question-card/question-card.directive";
import {OfferJourneyService} from "../../../services/offer-journey/offer-journey.service";
import {FELLO_JOURNEY_TASK_ID} from "../../../injection-token";

@Component({
  selector: "app-thank-you-card",
  templateUrl: "./que-thank-you.component.html",
  styleUrls: ["./que-thank-you.component.scss"]
})
export class QueThankYouComponent extends QuestionCardDirective {
  constructor(offerJourneyService: OfferJourneyService, @Inject(FELLO_JOURNEY_TASK_ID) public taskId: string) {
    super(offerJourneyService, taskId);
  }
}
